import React from "react";
import Image from "@components/image";
import Link from "@components/link";
import format from "date-fns/format"
import { parseISO } from "date-fns/esm"
import { ReactComponent as Arrow } from "@svgs/arrow.svg"
import { getUriFromDocument } from '@utils/routing'

const PostHero = ({ bgImage, title, categories, dateCreated, postType }) => {
    let date = dateCreated ? format(parseISO(dateCreated), "MMMM d, yyyy") : null
    
    return (
		<div className={`flex flex-col relative rounded-xl h-full overflow-hidden md:h-[359px] h-[335px] w-full mx-auto antialiased `}>
			<Image image={bgImage} maxWidth={1800} />
			<div
				className={`absolute inset-0 box-border flex flex-col justify-end items-start p-5 sm:p-10 gap-5 ${bgImage ? 'bg-gradient-to-b from-[rgba(0,0,0,0.15)] to-[rgba(0,0,0,0.50)]' : ''} `}
			>
                <Link ariaLabel={"Back to Blog List"} to={`/${postType + '/' + (categories?.[0]?.slug?.current ? categories[0]?.slug?.current : '')}`} className="btn flex items-center bg-white no-underline px-4 py-3 rounded-md focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-green-700" underline={null}>
                    <Arrow className={`arrow rotate-180`} />
				</Link>
                <div className="flex flex-col gap-1.5">
                    {categories && 
                            <nav>
                            <ul>
                            {categories.map(category => (
                                <li className="inline no-underline border-r-1 border-white last:border-r-0 pr-2 pl-2 first:pl-0" key={category.uid}>
                                <Link to={getUriFromDocument(category)} className="inline-block no-underline" underline={null}>
                                    <span className="inline-flex text-sm leading-5 tracking-widest text-white">
                                    {category.title}
                                    </span>
                                </Link>
                                </li>
                            ))}
                            </ul>
                        </nav>
                    }
                    {title && <h1 className={`relative headline flex text-2xl sm:text-4xl tracking-tight md:tracking-normal leading-none ${bgImage ? 'text-white' : 'text-dark-navy'}`}>{title}</h1>}
                </div>
                {date && <p className="text-[#C7C7C7] text-md font-medium">{ date }</p>}
			</div>
		</div>
	)
}

export default PostHero